import type {
    Author,
    Post,
    Attachment,
    Media,
    ExternalLink,
    UserMinimal, PriceModel
} from "~/repository/types";
import {PostScope} from "~/repository/types.d"
import AuthorModel from "./Author"
import UserMinimalModel from "./UserMinimal"

export default class PostModel implements Post {
    id: number;
    author: Author
    comments_count: number;
    expires: string;
    is_blurred: boolean;
    is_pinned: boolean;
    is_repost: boolean
    reposted_by: UserMinimal | null
    is_first_post: boolean;
    is_liked: boolean;
    is_owner: boolean;
    has_access: boolean;
    likes_count: number;
    media: Array<Media>;
    message: string;
    price: PriceModel;
    published_at: string;
    reposts_count: number;
    scope: PostScope;
    source_post_id: number | undefined
    content_flags: Arra<string>
    is_adult: boolean


    attachments: Array<Attachment<Post | ExternalLink>>;

    constructor(data: Post) {
        this.id = data.id;
        this.attachments = data.attachments ? data.attachments : []
        this.comments_count = data.comments_count
        this.expires = data.expires
        this.is_blurred = data.is_blurred
        this.is_repost = data.is_repost
        this.reposted_by = data.reposted_by ? new UserMinimalModel(data.reposted_by) : null
        this.is_pinned = data.is_pinned
        this.has_access = data.has_access
        this.is_liked = data.is_liked
        this.is_first_post = data.is_first_post
        this.is_owner = data.is_owner
        this.author = new AuthorModel(data.author)
        this.is_adult = data.is_adult
        this.likes_count = data.likes_count
        this.media = data.media
        this.message = data.message
        this.price = data.price
        this.published_at = data.published_at
        this.content_flags = data.content_flags
        this.reposts_count = data.reposts_count
        this.scope = data.scope
        this.source_post_id = data.source_post_id
    }
}
